import { useTranslation } from 'react-i18next'

import Landscape500SVG from '../../assets/images/500.svg?react'
import * as S from './styles'

const ServerError = () => {
	const { t } = useTranslation('translation')

	return (
		<S.Page
			alignItems="center"
			justifyContent="center"
			display="flex"
			flexDirection="column"
		>
			<Landscape500SVG />
			<S.Title>{t('translation:serverError')}</S.Title>
			<S.Subtitle>{t('translation:toast.error.server')}</S.Subtitle>
		</S.Page>
	)
}

export { ServerError }
